var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"type":"button","data-toggle":"modal","data-target":"#joinTheClubModal"}},[_vm._v("\n        "+_vm._s(_vm.btnText)+"\n        "),_c('svg',{staticClass:"arrow-right"},[_c('use',{attrs:{"xlink:href":"#arrow-right-2"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }